import useStore from "../../../store"
import ProspectDealerInformation from "./ProspectDealerInformation"
import Touches from "./Touches/Touches"
import { Tabs } from '@chakra-ui/react'
import DealerNameHeader from "../Dealer/DealerNameHeader"
import Spinner from "../../common/Spinner"
import { capitalize } from "../../../utilities/stringUtilities"
import { colors } from "../../../utilities/colors"

export default function ProspectDealerBody() {
  const dealer = useStore((state) => state.dealer)
  const dealerName = dealer?.attributes['name'] ? dealer.attributes['name'] : 'No Name'

  const PROSPECT_TABS = ["information", "touches"]

   return (
    <>
    {dealer ?
      <div className="mt-3 w-full">
        <Tabs.Root variant={'subtle'} defaultValue="information">
          <DealerNameHeader name={dealerName}/>
          <Tabs.List pb={4}>
            {PROSPECT_TABS.map((tab, index) =>
              <Tabs.Trigger
                data-testid={`${tab}-tab`}
                key={index}
                value={tab}
                _selected={{ color: 'white', bg: colors.grey700 }}
                color={colors.grey100}
                p={3}
                display="flex"
                justifyContent="center"
                borderRadius="full"
              >
                {capitalize(tab)}
              </Tabs.Trigger>
            )}
          </Tabs.List>
          <Tabs.Content p={0} value="information">
            <div data-testid='prospect-information'>
              <ProspectDealerInformation />
            </div>
          </Tabs.Content>
          <Tabs.Content p={0} value="touches">
            <Touches dealerId={dealer.id} />
          </Tabs.Content>
        </Tabs.Root>
      </div> :
      <div className="flex justify-center pt-3 w-full">
        <Spinner />
      </div>
    }
    </>
  )
}